export const reviews = [
  {
    initials: 'AR',
    name: 'Ananya & Rohit Sharma',
    role: 'Royal Wedding, 480 guests',
    stars: 5,
    quote:
      "Zafwa Royale turned our wedding into an actual fairy tale. Every gold detail, every bloom, every song cue was exactly as we dreamed — and somehow even better.",
  },
  {
    initials: 'MK',
    name: 'Meera Kapoor',
    role: 'Head of Marketing, Lumina Technologies',
    stars: 5,
    quote:
      "Our annual gala has never run this smoothly. Zafwa Royale's team managed 400+ guests, live entertainment and press with total calm and polish.",
  },
  {
    initials: 'DO',
    name: 'Devansh Oberoi',
    role: '40th Birthday Celebration',
    stars: 5,
    quote:
      'My 40th felt like a coronation. The décor, the lighting, the surprise performance — my guests are still talking about it months later.',
  },
  {
    initials: 'PK',
    name: 'Priya & Karan Malhotra',
    role: '25th Anniversary Celebration',
    stars: 5,
    quote:
      'From the first call to the last dance, we felt completely taken care of. Worth every rupee for the peace of mind alone.',
  },
  {
    initials: 'RS',
    name: 'Ritika Sen',
    role: 'Brand Director, Velure Cosmetics',
    stars: 4.5,
    quote:
      'Sleek, elegant, on brand. Zafwa Royale designed a product launch that felt premium the second guests walked in.',
  },
  {
    initials: 'SN',
    name: 'Sanya Nair',
    role: 'Engagement Ceremony',
    stars: 5,
    quote:
      "Professional, warm, and incredibly detail-oriented. They anticipated things we hadn't even thought to ask for.",
  },
]
